/* eslint-disable complexity */
import {
  ENROLL_SERIES_REQUEST,
  ENROLL_SERIES_SUCCESS,
  ENROLL_SERIES_FAILURE,
  GET_SERIES_BY_ID_REQUEST,
  GET_SERIES_BY_ID_SUCCESS,
  GET_SERIES_BY_ID_FAILURE,
  UPDATE_SERIES_REQUEST,
  UPDATE_SERIES_SUCCESS,
  UPDATE_SERIES_FAILURE,
  UPDATE_SERIES_BOOKING_PROGRESS_REQUEST,
  UPDATE_SERIES_BOOKING_PROGRESS_SUCCESS,
  UPDATE_SERIES_BOOKING_PROGRESS_FAILURE,
  GET_SERIES_BY_USER_ID_REQUEST, 
  GET_SERIES_BY_USER_ID_SUCCESS, 
  GET_SERIES_BY_USER_ID_FAILURE,
  SET_SERIES_SERVICE_DETAILS,
} from '../actions/series/types';

export const initialState = {
  seriesEnrolledUser: {
    data: {},
    loading: false,
    error: null,
  },
  seriesData: {
    data: {},
    loading: false,
    error: null,
  },
  updateSeries: {
    data: {},
    loading: false,
    error: null,
  },
  seriesBookingProgress: {
    data: {},
    loading: false,
    error: null,
  },
  seriesByUserId: {
    data: {},
    loading: false,
    error: null,
    requestComplete: false,
  },
  seriesServiceDetails: {
    data: {
      serviceId: '',
      bookApptFlag: false,
    },
    loading: false,
    error: null,
  },
};

// eslint-disable-next-line default-param-last
export default function (state = initialState, action) {
  switch (action.type) {
    case ENROLL_SERIES_REQUEST:
      return { ...state, seriesEnrolledUser: { ...state.seriesEnrolledUser, loading: action.isLoading, error: null } };
    case ENROLL_SERIES_SUCCESS:
      return { ...state, seriesEnrolledUser: { loading: action.isLoading, data: action.data, error: null } };
    case ENROLL_SERIES_FAILURE:
      return { ...state, seriesEnrolledUser: { ...state.seriesEnrolledUser, loading: action.isLoading, error: action.error } };
    case GET_SERIES_BY_ID_REQUEST:
      return { ...state, seriesData: { ...state.seriesData, loading: action.isLoading, error: null }};
    case GET_SERIES_BY_ID_SUCCESS:
      return { ...state, seriesData: { loading: action.isLoading, data: action.data, error: null }};
    case GET_SERIES_BY_ID_FAILURE:
      return { ...state, seriesData: { ...state.seriesData, loading: action.isLoading, error: action.error }};
    case UPDATE_SERIES_REQUEST:
      return { ...state, updateSeries: { ...state.updateSeries, loading: action.isLoading, error: null } };
    case UPDATE_SERIES_SUCCESS:
      return { ...state, updateSeries: { loading: action.isLoading, data: action.data, error: null } };
    case UPDATE_SERIES_FAILURE:
      return { ...state, updateSeries: { ...state.updateSeries, loading: action.isLoading, error: action.error } };
     case UPDATE_SERIES_BOOKING_PROGRESS_REQUEST:
      return { ...state, seriesBookingProgress: { ...state.seriesBookingProgress, loading: true, error: null } };
    case UPDATE_SERIES_BOOKING_PROGRESS_SUCCESS:
       return { ...state, seriesBookingProgress: { loading: false, data: action.payload, error: null } };
    case UPDATE_SERIES_BOOKING_PROGRESS_FAILURE:
      return { ...state, seriesBookingProgress: { loading: false, data: action.payload, error: null } };
    case GET_SERIES_BY_USER_ID_REQUEST:
      return { ...state, seriesByUserId: { ...state.seriesByUserId, loading: action.isLoading, error: null } };
    case GET_SERIES_BY_USER_ID_SUCCESS:
      return { ...state, seriesByUserId: { loading: action.isLoading, data: action.data, error: null, requestComplete: true } };
    case GET_SERIES_BY_USER_ID_FAILURE:
      return { ...state, seriesByUserId: { ...state.seriesByUserId, loading: action.isLoading, error: action.error, requestComplete: true } };
    case SET_SERIES_SERVICE_DETAILS:
      return { ...state, seriesServiceDetails: { data: action.data, loading: action.isLoading, error: null } };
    default:
      return state;
  }
}
